<p>contact-selection-dialog works!</p>
